import { useCallback } from 'react';
import { useQueryClient, type QueryKey } from '@tanstack/react-query';

export const useClientEditRefresh = () => {
  const queryClient = useQueryClient();

  const refreshQueries = useCallback(
    (queryKeys: readonly QueryKey[]) => Promise.all(queryKeys.map((queryKey) => queryClient.invalidateQueries({ queryKey }))),
    [queryClient],
  );

  return { refreshQueries };
};
